import React, {useEffect, useState} from 'react';
import {HashRouter as Router} from 'react-router-dom';
import LayoutBody from "../components/LayoutBody";
import MainNavigation from "../components/MainNavigation";
import RouteWrapper from "./routes";
import jwtDecode from "jwt-decode";
import {Button, Result} from "antd";
import KeycloakService from "../service/keycloak";

const Routes = () => {
    const keycloak = KeycloakService.getInstance();

    const [isAuthorized, setIsAuthorized] = useState(false);

    useEffect(() => {
        if (keycloak?.authenticated) { // Check if keycloak is initialized
            if (keycloak.token) {
                const token: any = jwtDecode(keycloak.token);
                if (token.realm_access?.roles?.includes('price_calculator')) {
                    setIsAuthorized(true);
                }
            } else {
                keycloak.logout();
            }
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    if (!isAuthorized && keycloak.authenticated) {
        return (
            <Result
                status="403"
                title="403"
                subTitle="Sorry, you are not authorized to access this page."
                extra={
                    <Button type="primary" onClick={() => {keycloak.logout()}}>Logout</Button>
                }/>
        )
    }

    return <Router>
        <LayoutBody navigationMenuConfig={<MainNavigation/>}>
            <RouteWrapper />
        </LayoutBody>
    </Router>;
}

export default Routes;
